import React from "react"
import {Box, TextField, Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import {accessoryRepository} from "../../../features/project/accessoryRepository";
import {Accessory, setAccessoryCount} from "../../../features/project/accessorySlice";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../reducers";

const TitleItem: React.FC = () => (
    <>
        <Grid size={12}>
            <Typography component="h1" variant="h4">
                Zubehör
            </Typography>
            <hr/>
        </Grid>
    </>
)

interface ProductProps {
    title: string;
    image: any;
    price: number;
    count: number;
    minOrderQuantity?: number;
    setCount: (value: number) => void;
}

const Product: React.FC<ProductProps> = (
    {
        title,
        image,
        price,
        count,
        minOrderQuantity = 1,
        setCount,
    }
) => {
    const getErrorMessage = (value: number) => {
        if (value === 0 || value >= minOrderQuantity) {
            return null;
        }
        return `Mindestbestellmenge ist ${minOrderQuantity}`;
    }
    const [error, setError] = React.useState<string | null>(getErrorMessage(count));
    const validateAndSetCount = (value: number) => {
        setError(getErrorMessage(value));
        setCount(value);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 438,
                width: '100%',
                position: 'relative',
            }}
        >
            <Box
                component="img"
                width={438}
                height={207}
                src={image}
                alt="Product"
                sx={{mb: 2}}
            />

            <Box display="flex" gap={2} alignItems="center" width="100%">
                <TextField
                    type="number"
                    size="small"
                    value={count}
                    onChange={event => {
                        const value = parseInt(event.target.value, 10);

                        validateAndSetCount(value);
                    }}
                    error={!!error}
                    sx={{width: 90}}
                    slotProps={{
                        htmlInput: {min: 0}
                    }}
                    onFocus={event => event.target.select()}
                />
                <Box display="flex" alignItems="center" flex={1}>
                    <Typography sx={{flex: 1}}>
                        {title}
                    </Typography>
                    <Typography>
                        {price.toLocaleString('de-CH', {style: 'currency', currency: 'CHF'})}
                    </Typography>
                </Box>
            </Box>

            {error && (
                <Typography
                    color="error"
                    variant="caption"
                    sx={{
                        mt: 1,
                        display: 'block',
                        width: '100%',
                        textAlign: 'left'
                    }}
                >
                    {error}
                </Typography>
            )}
        </Box>
    );
};
export const AccessorySection: React.FC = () => {
    const dispatch = useDispatch();
    const basketAccessories = useSelector((state: RootState) => state.project.accessory.items ?? []);
    const combinedAccessories = accessoryRepository.map(repositoryAccessory => ({
        ...basketAccessories.find((item: Accessory) => item.articleNumber === repositoryAccessory.articleNumber),
        ...repositoryAccessory
    }));

    return (
        <Grid container size={12} spacing={3}>
            <TitleItem/>
            <Box display="flex" flexWrap="wrap" gap={3}>
                {
                    combinedAccessories.map((product, index) => (
                        <Product
                            key={index}
                            title={product.title}
                            image={product.image}
                            price={product.price}
                            minOrderQuantity={product.minOrderQuantity}
                            count={product.count ?? 0}
                            setCount={(value: number) => {
                                dispatch(setAccessoryCount({
                                    articleNumber: product.articleNumber,
                                    count: value,
                                    unit: product.unit,
                                    description: product.title,
                                    price: product.price
                                }))
                            }}
                        />
                    ))
                }
            </Box>
        </Grid>
    )
}
